import fieldType from '@/enums/fieldType'
import vuei18n from '@/plugins/vuei18n'
import validator from '@/plugins/validator'
import store from '@/store/store'

const baseHeaders = [
  {
    text: vuei18n.t('base.id'),
    value: 'id',
    type: fieldType.PERMAMENT,
    sortable: false
  },
  {
    text: vuei18n.t('form.author'),
    value: 'created_by',
    type: fieldType.PERMAMENT,
    sortable: false
  },
  {
    text: vuei18n.t('form.created-at'),
    value: 'created_at',
    type: fieldType.PERMAMENT,
    sortable: false
  }
]


function validate (cell, field, type) {
  return validator.check(cell.value, field, type)
}

function translateValue (cell,field) {
  switch (cell.type) {
  case fieldType.RADIO :
      return cell.value ? field.values[cell.value - 1] != null ? field.values[cell.value - 1].value : "" : ""
  case fieldType.MULTIPLE :
      return cell.value.join('; ')
  case fieldType.TABLE :
      return cell.rows_amount
  default:
      return cell.value
  }
}

// TODO
export default class BaseAdapter {
  constructor (){//fields, confirmation = false, type = 1, showFullName = false) {
    if (this.constructor == BaseAdapter) {
      throw new Error("BaseAdapter is abstract class")
    }
  }

  getHeaders () {
    return this.headers
  }

  getRecords () {
    return this.records
  }

  loadForms (forms, indexInsteadOfId = false) {
    forms.forEach((form, index) => {
      var record = {
        id: indexInsteadOfId ? index + 1 : form.id, created_by: this.username(form.created_by),
        created_at: form.created_at, state: form.state, color: form.color
      }
      this.setAdditionalValues(record, form)

      form.results.forEach(cell => {
        var field = this.fields.find(field => field.order == cell.order)
        record[cell.order] = {
          id : field.id,
          data: translateValue(cell,field),
          validation: validate(cell, field, this.type)
        }
      })
      this.records.push(record)
    })
  }

  setUpHeaders () {
    this.headers = baseHeaders.slice(0)
    this.addAdditionalHeaders()

    this.fields.forEach(field => {
      this.headers.push({
        text: field.name,
        value: String(field.order),
        type: field.type,
        sortable: false
      })
    })
  }

  username (id) {
    let user =  id ? store.getters.user(id) != undefined ? store.getters.user(id) : null  : null
    if(!user){
      return id ? "" : null
    }
    return this.showFullName ? user.name + " " + user.surname : user.username
  }

  agencyName(idUser){
    let user =  idUser ? store.getters.user(idUser) != undefined ? store.getters.user(idUser) : null  : null
    return  user ? store.getters.agency(user.agency_id) != undefined ? store.getters.agency(user.agency_id).name : ""  : ""
  }

  addAdditionalHeaders(){

  }

  setAdditionalValues(){

  }
}
